import { Button } from 'antd';

export interface AIFollowUpChipProps {
  label: string;
  onClick: () => void;
}

export function AIFollowUpChip({ label, onClick }: AIFollowUpChipProps) {
  return (
    <Button size="small" shape="round" onClick={onClick} aria-label={label}>
      {label}
    </Button>
  );
}
